import PopupState, { bindMenu, bindTrigger } from 'material-ui-popup-state'
import { Button, Divider, Grid, ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material'
import SettingsIcon from '@mui/icons-material/Settings'
import CheckIcon from '@mui/icons-material/Check'
import NotificationsIcon from '@mui/icons-material/Notifications'
import EmailIcon from '@mui/icons-material/Email'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'
import { NetworkNotificationFrequences, NetworkNotificationPreferences } from '@/core/models/network.model'

type NotificationSettingsMenuProps = {
  onSetFrequency: (frequency: NetworkNotificationFrequences) => void
  onSetPreference: (preference: NetworkNotificationPreferences) => void
  selectedFrequency: NetworkNotificationFrequences
  selectedPreference: NetworkNotificationPreferences
}

export default function NotificationSettingsMenu(props: NotificationSettingsMenuProps) {
  const { onSetFrequency, onSetPreference, selectedFrequency, selectedPreference } = props
  const { enqueueSnackbar } = useSnackbar()
  const { t } = useTranslation()

  return (
    <PopupState variant="popover" popupId="notification-settings-menu">
      {(popupState) => (
        <>
          <Button {...bindTrigger(popupState)} color="primary" startIcon={<NotificationsIcon />} variant="contained">
            {t('page.network.notification.label')}
          </Button>
          <Menu
            {...bindMenu(popupState)}
            elevation={0}
            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
          >
            <Grid container direction="row">
              <Grid item>
                <MenuItem disabled>
                  <ListItemIcon>
                    <NotificationsIcon />
                  </ListItemIcon>
                  <ListItemText primary={t('page.network.notification.setFrequency')} />
                </MenuItem>
                {Object.values(NetworkNotificationFrequences).map((frequency) => (
                  <MenuItem
                    key={frequency}
                    onClick={() => {
                      onSetFrequency(frequency)
                      popupState.close()
                      enqueueSnackbar(t(`page.network.notification.frequencySet.${frequency}`), { variant: 'success' })
                    }}
                    selected={selectedFrequency === frequency}
                  >
                    <ListItemText primary={t(`page.network.notification.frequency.${frequency}`)} />
                    {selectedFrequency === frequency && <CheckIcon />}
                  </MenuItem>
                ))}
              </Grid>
              <Divider orientation="vertical" flexItem />
              <Grid item>
                <MenuItem disabled>
                  <ListItemIcon>
                    <EmailIcon />
                  </ListItemIcon>
                  <ListItemText primary={t('page.network.notification.setPreference')} />
                </MenuItem>
                {Object.values(NetworkNotificationPreferences).map((preference) => (
                  <MenuItem
                    key={preference}
                    onClick={() => {
                      onSetPreference(preference)
                      popupState.close()
                      enqueueSnackbar(t(`page.network.notification.preferenceSet.${preference}`), { variant: 'success' })
                    }}
                    selected={selectedPreference === preference}
                  >
                    <ListItemText primary={t(`page.network.notification.preference.${preference}`)} />
                    {selectedPreference === preference && <CheckIcon />}
                  </MenuItem>
                ))}
              </Grid>
            </Grid>
          </Menu>
        </>
      )}
    </PopupState>
  )
}
